import { ScanEye, Server, Shield, Zap } from 'lucide-react';
import { FaChartBar } from 'react-icons/fa';

import { FeatureConfig } from '../types/feature';

export const featureConfig: Record<string, FeatureConfig> = {
  serverAccess: {
    title: 'Upgrade to get a server',
    description: 'You need a subscription to access this feature!',
    features: [
      { text: '24/7 Private Server (28 locations)', icon: Server },
      { text: '2D Replay Advanced Mode', icon: FaChartBar },
      { text: 'Pattern Finder & Analytics', icon: ScanEye },
    ],
    videoSrc: 'https://www.youtube.com/embed/aD6bXRPgxto?si=IECJU-DdTeSwBUpN',
    buttonText: 'Upgrade Now',
  },
  serverAccessExpired: {
    title: 'Subscription Expired',
    description:
      "Your team's subscription has expired, and access to your server is now restricted. Renew your subscription to regain full control and keep your server running!",
    features: [
      { text: '24/7 Private Server (28 locations)', icon: Server },
      { text: '2D Replay Advanced Mode', icon: FaChartBar },
      { text: 'Pattern Finder & Analytics', icon: ScanEye },
    ],
    videoSrc: 'https://www.youtube.com/embed/aD6bXRPgxto?si=IECJU-DdTeSwBUpN',
    buttonText: 'Renew Now',
  },
  RecreateScenario: {
    title: 'Upgrade to a subcription to access this feature',
    description:
      'This is a brilliant tool, we agree! However, you must upgrade to a team subscription in order to get full access. Once that is done, find a way to crush your future opponents!',
    features: [
      { text: '24/7 Private Server (28 locations)', icon: Server },
      { text: '2D Replay Advanced Mode', icon: FaChartBar },
      { text: 'Pattern Finder & Analytics', icon: ScanEye },
    ],
    videoSrc: 'https://www.youtube.com/embed/uE-IlzcCX4k?si=BcINmSHfg2hQpv_k',
    buttonText: 'Upgrade Now',
  },
  AdvancedMode: {
    title: 'Upgrade to a subcription to access this feature',
    description:
      'Dig deeper into the match using the advanced mode! Pattern Finder, filter buy rounds, access grenade mode and much more - with a team subscription.',
    features: [
      { text: '24/7 Private Server (28 locations)', icon: Server },
      { text: '2D Replay Advanced Mode', icon: FaChartBar },
      { text: 'Pattern Finder & Analytics', icon: ScanEye },
    ],
    videoSrc: 'https://www.youtube.com/embed/WVEk4hZce-s?si=X6CTq1po1BXvhAto',
    buttonText: 'Upgrade Now',
  },
  FaceitImport: {
    title: 'Upgrade to access automatic FACEIT demo imports',
    description:
      'Get instant access to FACEIT matches with automatic demo import! Upgrade for one-click imports and immediate analysis.',
    features: [
      { text: 'One-click FACEIT demo imports', icon: Server },
      { text: 'Instant match analysis', icon: FaChartBar },
      { text: 'Pattern Finder & Analytics', icon: ScanEye },
    ],
    videoSrc: 'https://www.youtube.com/embed/WVEk4hZce-s?si=X6CTq1po1BXvhAto',
    buttonText: 'Upgrade Now',
  },
  TrainingAnnouncement: {
    title: 'Training mode release!',
    description:
      'We just launched the beta version of our new training modes. Check them out!',
    features: [
      { text: 'Defend sites vs realistic bots', icon: Shield },
      { text: 'High stakes prefire trainer', icon: Zap },
    ],
    videoSrc: 'https://www.youtube.com/embed/Si2BbeJfB6g?si=R2gmj91QkQF39Z9o',
    thumbnailSrc: '/images/training-defense.png',
    thumbnailText: 'Introduction: Training',
    buttonText: 'Get started',
    endDate: 1756553817,
  },
} as const;
